import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import en from './en'
import cz from './cz'

const resources = {
  en: {
    translation: en
  },
  cz: {
    translation: cz
  }
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",

  keySeparator: false
});

export default i18n;
